// next.js — Ziel nach der Anmeldung. Nur eigene Bereiche, nie fremde Hosts ('//evil', 'https:…', '/\\evil').
const OK = /^\/(?:next\/(?:app|admin|operator)|app|admin|operator)(?:[/?#][^\s\\]*)?$/;
import { P } from '../shared/prefix.js';
export const DEFAULT_NEXT = P + '/app';
export function safeNext(raw) {
  const s = String(raw || '').trim();
  if (!s.startsWith('/') || s.startsWith('//') || s.includes('\\')) return DEFAULT_NEXT;
  return OK.test(s) ? s : DEFAULT_NEXT;
}
/** Server-Fehlertext bevorzugen; 429 kann auch vom globalen /auth/-Limiter (englisch) kommen. */
export function authError(status, data, fallback, rateLimited) {
  if (status === 429) return rateLimited;
  if (data && typeof data.error === 'string' && data.error) return data.error;
  return fallback;
}
